<template>
  <div
    :class="headerCls"
    :style="headerStyle"
  >
    <slot />
    <div
      v-if="hasBottom"
      class="header-bottom"
    >
      <slot name="bottom" />
    </div>
    <el-collapse-transition>
      <div v-show="moreVisible">
        <slot name="extra" />
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import xpcConfig from '../../config';

export default {
  name: 'RtHeader',
  props: {
    showBack: {
      type: Boolean,
      default: true
    },
    autoBack: {
      type: Boolean,
      default: true
    },
    sticky: {
      type: Boolean,
      default: true
    },
    stickyTop: {
      type: Number,
      default: undefined
    },
    marginBottom: {
      type: Number,
      default: undefined
    }
  },
  data () {
    return {
      moreVisible: false
    };
  },
  computed: {
    hasBottom () {
      return !!this.$slots.bottom;
    },
    headerCls () {
      let cls = {
        'rt-header': true
      };

      // 组件自定义的sticky为第一优先级，当自定义sticky为false时，忽略全局配置
      if (this.sticky) {
        cls['rt-xpc-sticky'] = !!xpcConfig.get('header.sticky');
      }

      return cls;
    },
    headerStyle () {
      let style = {};

      if (this.sticky) {
        style['top'] = this.stickyTop !== undefined ? this.stickyTop : xpcConfig.get('header.stickyTop');
      }

      if (this.marginBottom !== undefined) {
        style['marginBottom'] = this.marginBottom
      }

      return style;
    }
  },
  methods: {
    showMore () {
      this.moreVisible = true;
    },
    hideMore () {
      this.moreVisible = false;
    },
    back () {
      if (this.autoBack) {
        this.$route.back();
        return;
      }
      this.$emit('back');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtHeader.vue?8b016590